// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("css/" + chunkId + "." + "8382efdf" + ".css");